module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione2 b.bd8527c9.svg";